import React from "react";
import MediaDirectoryTree from "../component/MediaDirectoryTree";

const MediaDirectoryTreeContainer = () => (<MediaDirectoryTree />)

export default MediaDirectoryTreeContainer;